export default (state = [], action) => {
  switch (action.type) {
    case "CREATE_PUBLIC_BENEFIT":
      return [...state, action.payload.publicBenefit];
    case "UPDATE_PUBLIC_BENEFIT":
      return action.payload.publicBenefit;
    case "DELETE_PUBLIC_BENEFIT":
      return state.filter((publicBenefit) => {
        return publicBenefit.id !== action.payload.publicBenefit.id;
      });
    default:
      return state;
  }
};
